export default __webpack_public_path__ + "static/media/truck-tuk-tuk.813bef11.png";